import React from 'react';

const childrenArrayWrapper = (
  children: React.ReactNode,
  Wrapper: React.ComponentType<React.PropsWithChildren>,
  hasOnlyWrapperInMagnolia = false,
  withMagnoliaCommentsProp = false
): React.ReactNode[] => {
  const childrenArr = React.Children.toArray(children);

  if (typeof window !== 'undefined' && window.USE_MAGNOLIA_RENDERER) {
    return childrenArr.reduce<React.ReactNode[]>((acc, child, idx, all) => {
      if (typeof child === 'string') {
        const [areaCommentStart] = child.match(/<!-- cms:area(.*?)-->/) ?? [''];
        const [areaCommentEnd] = child.match(/<!-- \/cms:area -->/) ?? [''];
        const [componentCommentStart] = child.match(
          /<!-- cms:component(.*?)-->/
        ) ?? [''];

        const componentCommentEnd = `<!-- /cms:component -->`;

        if (areaCommentStart) {
          acc = [...acc, areaCommentStart];
        }

        if (idx !== all.length - 1) {
          const nextChild = all[idx + 1];
          acc = [
            ...acc,
            withMagnoliaCommentsProp && React.isValidElement(nextChild) ? (
              React.createElement(nextChild.type, {
                key: nextChild.key,
                ...nextChild.props,
                magnoliaComments: [componentCommentStart, componentCommentEnd],
              })
            ) : (
              <Wrapper key={idx}>
                {componentCommentStart}
                {all[idx + 1]}
                {componentCommentEnd}
              </Wrapper>
            ),
          ];
        }

        if (areaCommentEnd) {
          acc = [...acc, componentCommentEnd, areaCommentEnd];
        }

        return acc;
      }
      return acc;
    }, []);
  } else {
    const CustomWrapper = hasOnlyWrapperInMagnolia ? React.Fragment : Wrapper;
    return childrenArr.map((child, idx) => (
      <CustomWrapper key={idx}>{child}</CustomWrapper>
    ));
  }
};

export default childrenArrayWrapper;
